export default {
  path: 'accommodations',
  name: 'accommodations',
  redirect: { name: 'accommodations.listing' },
  component: () =>
    import(
      /* webpackChunkName: "accommodations" */ '@/views/Home/Accommodations'
    ),
  children: [
    {
      path: '/',
      name: 'accommodations.listing',
      component: () =>
        import(
          /* webpackChunkName: "accommodations" */ '@/views/Home/Accommodations/AccommodationList'
        )
    },
    {
      path: 'create',
      name: 'accommodations.create',
      component: () =>
        import(
          /* webpackChunkName: "accommodations" */ '@/views/Home/Accommodations/CreateAccommodation'
        )
    },
    {
      path: 'update/:id',
      name: 'accommodations.update',
      component: () =>
        import(
          /* webpackChunkName: "accommodations" */ '@/views/Home/Accommodations/UpdateAccommodation'
        )
    }
  ]
}
